module.exports = __webpack_public_path__ + "img/Nicole+Jon-58.ae39ebe7.jpg";